// Step constants for the WLC Cancel Modal
export const CANCEL_MODAL_STEPS = {
  REASON_SELECTION: 1,
  PAUSE_OFFER: 2,
  DOWNGRADE_OFFER: 3,
  PAUSE_CONFIRMATION: 4,
  DOWNGRADE_CONFIRMATION: 5,
  NEXT_ACTION: 6,
  CANCELLATION_SUCCESS: 7,
  STAY_CONFIRMATION: 8,
  ERROR_CONFIRMATION: 9,
  SUPPORT_REQUEST_SUBMITTED: 10
};

// Total number of steps in the cancellation flow
export const TOTAL_STEPS = 10;

// Cancellation reason options
export const CANCELLATION_REASONS = [
  { value: 'tooBusy', label: "I'm too busy to use it right now" },
  { value: 'tooExpensive', label: "It's more than I can afford right now" },
  { value: 'notUsing', label: "I haven't been using it much lately" },
  { value: 'technicalIssues', label: "I've been having technical or login issues" },
  { value: 'goalAchieved', label: "I reached my goal and don't need ongoing access" },
  { value: 'other', label: 'Other (please specify)' }
];

// Modal configuration
export const MODAL_CONFIG = {
  size: 'lg',
  className: 'wlc-cancel-modal',
  title: 'Cancel WHOLE Life Club Membership'
};
